export const ALLOWED_MEDIA = {
  // Down
  xsDown: '(max-width: 479px)',
  smDown: '(max-width: 639px)',
  mdDown: '(max-width: 767px)',
  lgDown: '(max-width: 1023px)',
  xlDown: '(max-width: 1279px)',

  // Up
  xsUp: '(min-width: 480px)',
  smUp: '(min-width: 640px)',
  mdUp: '(min-width: 768px)',
  lgUp: '(min-width: 1024px)',
  xlUp: '(min-width: 1280px)',

  // Only
  xsOnly: '(min-width: 480px) and (max-width: 639px)',
  smOnly: '(min-width: 640px) and (max-width: 767px)',
  mdOnly: '(min-width: 768px) and (max-width: 1023px)',
  lgOnly: '(min-width: 1024px) and (max-width: 1279px)',

  // Range multi-steps
  xsToSm: '(min-width: 480px) and (max-width: 767px)',
  xsToMd: '(min-width: 480px) and (max-width: 1023px)',
  xsToLg: '(min-width: 480px) and (max-width: 1279px)',
  smToMd: '(min-width: 640px) and (max-width: 1023px)',
  smToLg: '(min-width: 640px) and (max-width: 1279px)',
  mdToLg: '(min-width: 768px) and (max-width: 1279px)',

  // Orientation
  portrait: '(max-width: 1279px) and (orientation: portrait)',
  landscape: '(max-width: 1279px) and (orientation: landscape)',
} as const;

export const ALLOWED_WIDTHS = [
  256, 384, 640, 750, 828, 1080, 1280, 1440, 1680, 1920, 2048, 2560, 2880, 3360,
] as const;

export const RESPONSIVE_IMAGE_DEFAULTS = {
  media: {
    mobile: ALLOWED_MEDIA.lgDown,
    desktop: ALLOWED_MEDIA.lgUp,
  },
  sizes: {
    mobile: '100vw',
    desktop: '100vw',
  },
  widths: {
    mobile: [640, 750, 828, 1080, 1280] as const,
    desktop: [1280, 1440, 1680, 1920, 2048, 2560] as const,
  },
} as const;
